module.exports = __webpack_public_path__ + "static/media/WindsorBOLD.c58db826.svg";